import { Box } from "@mui/material";
import type { PaymentActionsProps } from "Components/Dashboard/BalanceWithPaymentActions/types";
import { PaymentAction } from "./PaymentAction";

export const PaymentActions = ({
  payMeAction,
  sendPaymentAction,
}: PaymentActionsProps) => (
  <Box
    display="flex"
    justifyContent="space-around"
    maxWidth="300px"
    width="100%"
    gap={18}
  >
    <PaymentAction
      isIconFlipped
      label={payMeAction.text}
      to={payMeAction.link}
      isDisabled={payMeAction.isDisabled}
    />
    <PaymentAction
      label={sendPaymentAction.text}
      to={sendPaymentAction.link}
      isDisabled={sendPaymentAction.isDisabled}
    />
  </Box>
);
